'use client'

import * as React from 'react'
import { Amplitude } from '@repo/analytics/amplitude'
import { Analytics as AnalyticsComponent } from '@repo/analytics-nextjs'
import { facebookEvent, FacebookEventName } from '@repo/analytics/facebook'
import { bingEvent, BingEventName } from '@repo/analytics/bing'
import { trackRegistrationConversion } from '@repo/analytics/google-site-tag'
import { useUserId } from '@repo/cf-user/hooks/use-user-data'

import dynamic from 'next/dynamic'

const AlgoliaAnalytics = dynamic(() => import('./algolia').then(m => m.AlgoliaAnalytics), {
  ssr: true,
})

// oxlint-disable-next-line require-await
export async function trackRegistration({
  isGAdsSignup,
  isNew,
  userId,
}: {
  isGAdsSignup: boolean
  isNew: boolean
  userId: string
}) {
  if (isGAdsSignup) {
    trackRegistrationConversion()
  }

  if (isNew) {
    facebookEvent(FacebookEventName.COMPLETE_REGISTRATION)
    bingEvent(BingEventName.COMPLETE_REGISTRATION, {
      event_category: 'user',
      event_label: userId,
    })
  }
}

export const Analytics = ({
  noAlgolia = false,
  noAmplitude = false,
  autoLogin,
}: {
  noAlgolia?: boolean
  noAmplitude?: boolean
  autoLogin?: boolean
}) => {
  const userId = useUserId()

  return (
    <>
      <AnalyticsComponent userId={userId} autoLogin={autoLogin} />
      {!noAmplitude ? <Amplitude /> : null}
      {!noAlgolia ? <AlgoliaAnalytics /> : null}
    </>
  )
}
